import { Swiper } from 'swiper';

const resultSlider = {
  init() {
    const sliders = document.querySelectorAll<HTMLElement>('.c-results-slider .swiper');
    if (sliders.length) {
      sliders.forEach((slider) => {
        new Swiper(slider, {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 40,
          loop: true,
          breakpoints: {
            1024: {
              spaceBetween: 64,
            },
          },
        });
      });
    }
  },
};

export { resultSlider };
